import { object, string } from 'yup';
import { nameRegex, emailRegex, onlyASCII } from './validation-rules';

export const contactUsSchema = object({
  contact_name: string()
    .required('Name is required')
    .matches(nameRegex, 'Name must contain English letters only'),
  contact_email: string()
    .required('Email Address is required')
    .matches(emailRegex, 'Invalid email format'),
  contact_subject: string().matches(onlyASCII, 'Subject must contain English letters only'),
  contact_message: string()
    .required('Message is required')
});
